module.exports = __webpack_public_path__ + "img/credit-card-grey24.0ff40f90.svg";